export enum BoostableType {
    Yes = 'Yes',
    No = 'No',
    Promoted = 'Promoted',
    Pending = 'Pending'
}
